module.exports = __webpack_public_path__ + "static/img/credit_score.bc9f2cd9.png";